<template>
  <WidgetPanel v-if="success">
    <template #header>
      <div class="flex justify-between">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Podcast-Ziele
        </h3>
        <button @click="onEdit">
          <PencilSquareIcon class="flex-shrink-0 h-5 w-5 text-gray-400" />
        </button>
      </div>
    </template>
    <template #default>
      <div class="w-full bg-white divide-y divide-slate-200">
        <dl class="sm:divide-y sm:divide-gray-200">
          <div class="wrapper">
            <dt class="label">
              <CoverageTooltip />
            </dt>
            <dd class="value">
              <Potential :value="resource.coverage" />
            </dd>
          </div>
          <div class="wrapper">
            <dt class="label">
              <ThroughputTooltip />
            </dt>
            <dd class="value">
              <Potential :value="resource.throughput" />
            </dd>
          </div>
          <div class="wrapper">
            <dt class="label">
              <ReputationTooltip />
            </dt>
            <dd class="value">
              <Potential :value="resource.reputation" />
            </dd>
          </div>
          <div class="wrapper">
            <dt class="label">
              <InteractionTooltip />
            </dt>
            <dd class="value">
              <Potential :value="resource.interaction" />
            </dd>
          </div>
          <div class="wrapper">
            <dt class="label">
              <MonetizationTooltip />
            </dt>
            <dd class="value">
              <Potential :value="resource.monetization" />
            </dd>
          </div>
          <div class="wrapper">
            <dt class="label">
              <ExpertiseTooltip />
            </dt>
            <dd class="value">
              <Potential :value="resource.expertise" />
            </dd>
          </div>
          <div class="wrapper">
            <dt class="label">
              <ReferabilityTooltip />
            </dt>
            <dd class="value">
              <Potential :value="resource.referability" />
            </dd>
          </div>
          <div class="wrapper">
            <dt class="label">
              <EnjoymentTooltip />
            </dt>
            <dd class="value">
              <Potential :value="resource.enjoyment" />
            </dd>
          </div>
        </dl>
      </div>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useRetrieveResource } from '@/client/actions';

const props = defineProps({podcast: Object});
const router = useRouter();

const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/objective');
const action = useRetrieveResource(target);

const { retrieve, retrieving, resource, success } = action;

const mounted = onMounted(() => retrieve());
const watcher = watch(target, (v, _) => retrieve());

const onEdit = () => router.push({name: 'podcast.edit.objective'});
</script>

<style scoped>
.button-icon
{
 @apply h-5 w-5;
 @apply text-gray-500;
};

.button-open
{
  @apply rotate-180;
  @apply transform;
};

.wrapper
{
  @apply flex flex-row;
  @apply justify-between items-center;
  @apply pl-2 pr-6 py-1;
}

.label
{
  @apply text-sm font-medium text-gray-700;
}

.value
{
  @apply text-sm text-gray-900;
}
</style>

